<template>

  <li
    class="candidate-item draggable" 
    :class="candidate.placement.status"
    :data-draggable="JSON.stringify({candidate_id: candidate._id, placement_id: candidate.placement._id})"
    @mouseenter="checkbox=true"
    @mouseleave="checkbox=false"
    @click="$router.push(toRoute)"
    style="cursor: pointer;">

    <div class="photo">
      <input
        v-if="checkboxShow"
        type="checkbox" 
        :checked="isSelected" 
        :value="candidate._id" 
        @click="setCheck"
        class="checkbox">

      <Avatar
        :src="imgSrc"
        :name="candidate.name"
        size="44px"
        radius="22px"
        resize="100x100x1" />
    </div>

    <div class="content">
      <div class="title">
        <span>{{ candidate.name }}</span>
        <span 
          class="badge badge-danger" 
          v-if="candidate.placement.new">
          novo
          </span>
      </div>
      <div class="subtitle">
        <span>{{ candidate.placement.stage_date | moment('fromNow', $i18n.locale) }}</span>
        <span class="ml-1">
          <i class="far fa-calendar-alt text-info" v-if="candidate.next_event" />
          <i class="fas fa-hand-point-right text-secondary" v-if="candidate.placement.referral_name" />
          <i class="fa-solid fa-circle-user text-info" v-if="candidate.origin === 'internal_applied'" />
        </span>
      </div>
    </div>

  </li>

</template>

<script>
import config from '@/config'
import Avatar from '@/components/Parts/Avatar'

export default {
  name: 'JobBoardStagesItem',
  components: {
    Avatar
  },
  props: [
    'candidate'
  ],
  data () {
    return {
      checkbox: false
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    },
    isSelected () {
      const selecteds = this.$store.getters.getCandidateSelectedIds
      return selecteds.includes(this.candidate._id)
    },
    checkboxShow () {
      return this.permissions.includes('manage_candidates') && (this.checkbox || this.isSelected)
    },
    toRoute () {
      return {
        query: {
          ...this.$clone(this.$route.query),
          candidate_id: this.candidate._id,
          candidate_job_id: this.candidate.placement.job_id,
          candidate_job_stage_id: this.candidate.placement.stage_id ? this.candidate.placement.stage_id._id : null
        }
      }
    },
    imgSrc () {
      const defaultImageUrl = config.default_image_url.candidate
      const url = this.candidate.photo_media_url
      return url && !url.includes(defaultImageUrl) ? url : null
    }
  },
  created () {
  },
  methods: {
    /*
    setCheck
    */
    setCheck (event) {
      this.$store.dispatch('toggleCandidateSelected', event.target.value)
      event.stopPropagation()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.candidate-item{
  display: flex;
  position: relative;
  align-items: center;
  background: #ffffff;
  margin: 0 0 8px 0;
  border-radius: 5px;
  box-shadow: 1px 0 3px rgba(0, 0, 0, 0.1);
  padding: 7px;
}
  .candidate-item:hover{
    background: #cce5ff;
  }
  .candidate-item.disqualified{
    background: rgba(0, 0, 0, 0.1);
  }
.candidate-item .photo{
  flex: 0 46px;
  margin-right: 8px;
}
  .candidate-item .photo img{
    width: 100%;
    border-radius: 100px;
  }
.candidate-item .content{
  flex: 1 100px;
  font-size: 0.9em;
  line-height: 1.2em;
}
  .candidate-item .content .title{
    margin-bottom: 0.2em;
  }
  .candidate-item .content .title a{
    color: #000000;
  }
  .candidate-item .content .subtitle{
    color: rgba(0,0,0,0.5);
    font-size: 0.95em;
    line-height: 1.3em;
  }
.candidate-item .checkbox{
  position: absolute;
  left: 0px;
  top: 0px;
  z-index: 2;
}
</style>



// WEBPACK FOOTER //
// src/components/Job/JobBoard/JobBoardStagesItem.vue